import * as Filtrator from '@Stores/Filtrator';

import type { FiltersData, FiltersGroupItemData, FiltersValue } from '@Types/Filters';
import type { CreateTags } from './typings';

const id = 'textile';

export function init(tags: CreateTags) {
  const colorsFilter: FiltersValue[] = Object.values(tags.colors).map((color) => ({
    parameterId: '40',
    type: 'variant',
    name: color.title,
    value: [color.id],
    meta: {
      color: color.code,
    },
  }));

  const collectionsFilter: FiltersValue[] = Object.values(tags.collections).map((collection) => ({
    parameterId: '20',
    type: 'variant',
    name: collection.title,
    value: [collection.id],
    meta: {
      color: '',
    },
  }));

  const materialsFilter: FiltersValue[] = Object.values(tags.materials).map((material) => ({
    parameterId: '50',
    type: 'variant',
    name: material.title,
    value: [material.id],
    meta: {
      color: '',
    },
  }));

  const filters: FiltersData = {
    filters: [
      {
        id: '1',
        name: 'Цвет',
        theme: 'checkbox',
        items: [
          {
            theme: 'checkbox',
            parameterId: '40',
          },
        ],
      },
      {
        id: '3',
        name: 'Коллекция',
        theme: 'checkbox',
        items: [
          {
            theme: 'checkbox',
            parameterId: '20',
          },
        ],
      },
      {
        id: '4',
        name: 'Тип ткани',
        theme: 'checkbox',
        items: [
          {
            theme: 'checkbox',
            parameterId: '50',
          },
        ],
      },
    ],
    parameterValues: [...colorsFilter, ...collectionsFilter, ...materialsFilter],
    parameters: {
      '40': {
        name: 'Цвет',
        unit: '',
        default: [],
      },
      '20': {
        name: 'Коллекция',
        unit: '',
        default: [],
      },
      '50': {
        name: 'Тип ткани',
        unit: '',
        default: [],
      },
    },
    totalCount: 0,
    withoutUrl: true,
    groupBy: [
      {
        id: 'by-collection',
        name: 'По коллекции',
        selected: true,
      },
      {
        id: 'by-color',
        name: 'По цвету',
        selected: false,
      },
    ],
  };
  return Filtrator.init(id, filters);
}

export function getStores() {
  return Filtrator.getStores(id);
}

export const updateTotalCount = (totalCount: number) => {
  return Filtrator.updateTotalCount(id, totalCount);
};

export const applyFilters = () => {
  return Filtrator.applyFilters(id);
};

export function setGroup(option: FiltersGroupItemData) {
  return Filtrator.setGroup(id, option);
}

export function usePriorityFilters() {
  return Filtrator.usePriorityFilters(id);
}

export function useAppliedValues() {
  return Filtrator.useAppliedValues(id);
}

export function useFiltrator() {
  return Filtrator.useFiltrator(id);
}

export function useGroups() {
  return Filtrator.useGroups(id);
}

export function useSelectedGroups() {
  return Filtrator.useSelectedGroups(id);
}
